module.exports = __webpack_public_path__ + "img/SMP_profil-268450025-1400x900.a19e81d9.jpg";